import { render, staticRenderFns } from "./base-select-search.vue?vue&type=template&id=15706c78"
import script from "./base-select-search.vue?vue&type=script&lang=js"
export * from "./base-select-search.vue?vue&type=script&lang=js"
import style0 from "./base-select-search.vue?vue&type=style&index=0&id=15706c78&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports